import {
  CSS_DOMAIN,
  EPS_DOMAIN,
  TMS_DOMAIN,
  DDP_DOMAIN,
  TELEMATICS_DOMAIN,
  DRIVER_ADMIN_DOMAIN,
  NOTIFICATIONS_DOMAIN,
} from '~/shared/config/env'
import {
  BalanceIcon,
  CarsIcon,
  DebtsIcon,
  DriversIcon,
  InspectionsIcon,
  OrganizationsIcon,
  PenaltiesIcon,
  RepairOrdersIcon,
  RoadAccidentsIcon,
  TaxiparkIcon,
  TelematicsIcon,
  WorkRulesIcon,
  DashboardsIcon,
  DriverAppIcon,
  PushAppIcon,
  LeadIcon,
} from '~/shared/ui/icons'

import { HomepageCardProps } from '../type'

export const useCards = (): HomepageCardProps[] => {
  return [
    {
      title: 'cars',
      link: `${TMS_DOMAIN}cars`,
      description: 'fleet management',
      icon: <CarsIcon />,
    },
    {
      title: 'drivers',
      description: 'driver verification',
      link: `${TMS_DOMAIN}drivers`,
      icon: <DriversIcon />,
    },
    {
      title: 'balance',
      description: 'transactions and appeals',
      link: `${TMS_DOMAIN}balance/balance-histories`,
      icon: <BalanceIcon />,
    },
    {
      title: 'work conditions',
      description: 'work conditions management',
      link: `${TMS_DOMAIN}work-rules`,
      icon: <WorkRulesIcon />,
    },
    {
      title: 'taxi park',
      description: 'taxi park settings',
      link: `${TMS_DOMAIN}taxipark/information`,
      icon: <TaxiparkIcon />,
    },
    {
      title: 'organizations',
      description: 'organization management',
      link: `${TMS_DOMAIN}organizations/car-rentals`,
      icon: <OrganizationsIcon />,
    },
    {
      title: 'inspections',
      description: 'car inspections',
      link: `${CSS_DOMAIN}inspections`,
      icon: <InspectionsIcon />,
    },
    {
      title: 'fines',
      description: 'fine management',
      link: `${EPS_DOMAIN}penalties`,
      icon: <PenaltiesIcon />,
    },
    {
      title: 'debts',
      description: 'debt management',
      link: `${DDP_DOMAIN}debts`,
      icon: <DebtsIcon />,
    },
    {
      title: 'telematics',
      description: 'car lock/unlock',
      link: `${TELEMATICS_DOMAIN}`,
      icon: <TelematicsIcon />,
    },
    {
      title: 'repair orders',
      description: 'repair order management',
      link: `${CSS_DOMAIN}repair-orders`,
      icon: <RepairOrdersIcon />,
    },
    {
      title: 'accidents',
      description: 'accidents and insurance',
      link: `${CSS_DOMAIN}road-accidents`,
      icon: <RoadAccidentsIcon />,
    },
    {
      title: 'dashboards',
      description: 'charts and reports',
      link: `${TMS_DOMAIN}dashboards`,
      icon: <DashboardsIcon />,
    },
    {
      title: 'driver mobile application',
      description: 'content management',
      link: `${DRIVER_ADMIN_DOMAIN}stories`,
      icon: <DriverAppIcon />,
    },
    {
      title: 'leads',
      description: 'lead management',
      link: `${DRIVER_ADMIN_DOMAIN}leads`,
      icon: <LeadIcon />,
    },
    {
      title: 'push notifications',
      description: 'push notifications management',
      link: `${NOTIFICATIONS_DOMAIN}mass-mailing`,
      icon: <PushAppIcon />,
    },
  ]
}
